// // import React, { useEffect } from "react";
// // import Navbar from "../components/Navbar";
// // import Footer from "../pages/main/footer";
// // import "./ShippingPolicy.css";

// // const ShippingPolicy = () => {
// //   useEffect(() => {
// //     const fadeElements = document.querySelectorAll(".fade-in-up");
// //     fadeElements.forEach((el, index) => {
// //       el.style.animationDelay = `${index * 0.2}s`;
// //       el.classList.add("fade-in-up");
// //     });
// //   }, []);

// //   return (
// //     <>
// //       <Navbar />
// //       <div className="shipping-policy-container">
// //         <div className="shipping-policy-header">
// //           <h1 className="shipping-policy-title">Shipping & Delivery Policy</h1>
// //           <p className="shipping-policy-subtitle">
// //            Last updated on Oct 3 2025
// //           </p>
// //         </div>

// //         <div className="shipping-policy-content fade-in-up">
// //           <p className="shipping-intro-text">
// //             For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and/or speed post only.
// //           </p>

// //           <div className="shipping-section fade-in-up">
// //             <p className="shipping-section-content">
// //              Orders are shipped within 8-14 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
// //             </p>
// //           </div>

// //           <div className="shipping-section fade-in-up">
// //             <p className="shipping-section-content">
// //              SENTINIX TECH SOLUTIONS PRIVATE LIMITED is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 8-14 days from the date of the order and payment or as per the delivery date agreed at the time of order confirmation.
// //             </p>
// //           </div>

// //           <div className="shipping-section fade-in-up">
// //             <p className="shipping-section-content">
// //             Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration.
// //             </p>
// //           </div>

// //           <div className="shipping-section fade-in-up">
// //             <p className="shipping-section-content">
// //              For any issues in utilizing our services you may contact our helpdesk:
// //             </p>
// //           </div>

// //           <div className="shipping-section fade-in-up">
// //             <h3 className="shipping-section-title">Contact Us</h3>
// //             <div className="shipping-contact-info">
// //               <div className="shipping-contact-details">
// //                 <div className="shipping-contact-item">
// //                   <b>Email:</b> sentinixtechsolutions@gmail.com
// //                 </div>
// //                 <div className="shipping-contact-item">
// //                   <b>Phone:</b> +91-8012288811
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       <Footer />
// //     </>
// //   );
// // };

// // export default ShippingPolicy;

// import React, { useState, useEffect } from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../pages/main/footer";
// import "./CancellationPolicy.css"; // ✅ Same CSS reuse
// import api from "../services/httpService";

// const ShippingPolicy = () => {
//   const [policy, setPolicy] = useState(null);
//   const [contactInfo, setContactInfo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [themeColors, setThemeColors] = useState({
//     color1: "#f83600",
//     color2: "#fe8c00"
//   });

//   useEffect(() => {
//     fetchPolicy();
//     fetchContact();
//     fetchThemeColors();
//   }, []);

//   const fetchThemeColors = async () => {
//     try {
//       const res = await api.get("/sentinix/dashboardsettings");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const latest = allData.sort((a, b) => b.id - a.id)[0];

//         if (latest) {
//           const color1 = latest.color1 || "#f83600";
//           const color2 = latest.color2 || "#fe8c00";
          
//           setThemeColors({ color1, color2 });
          
//           // Apply to CSS variables
//           document.documentElement.style.setProperty("--theme-color1", color1);
//           document.documentElement.style.setProperty("--theme-color2", color2);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching theme colors:", err);
//     }
//   };

//   const fetchPolicy = async () => {
//     try {
//       const res = await api.get("/sentinix/shippinganddelivery");
//       if (res.data.success && res.data.data) {
//         const data = Array.isArray(res.data.data)
//           ? res.data.data.filter(d => !d.isDeleted).sort((a, b) => b.id - a.id)[0]
//           : res.data.data;
//         setPolicy(data || null);
//       }
//     } catch (err) {
//       console.error("Error fetching shipping policy:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchContact = async () => {
//     try {
//       const res = await api.get("/sentinix/contactforms");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const info = allData.find(item => item.title && item.title.trim() !== "");
//         setContactInfo(info || null);
//       }
//     } catch (err) {
//       console.error("Error fetching contact:", err);
//     }
//   };

//   const renderContent = (text) => {
//     if (!text) return <p className="cp-empty">No content available.</p>;
//     return text.split("\n").map((line, idx) => {
//       const trimmed = line.trim();
//       if (!trimmed) return <br key={idx} />;
//       const isSubHeading = /^\d+\.\d+/.test(trimmed);
//       const isHeading    = /^\d+\./.test(trimmed);
//       const isBullet     = trimmed.startsWith("•") || trimmed.startsWith("-");
//       if (isSubHeading) return <h4 key={idx} className="cp-subheading">{trimmed}</h4>;
//       if (isHeading)    return <h3 key={idx} className="cp-heading">{trimmed}</h3>;
//       if (isBullet)     return (
//         <div key={idx} className="cp-bullet">
//           <span className="cp-bullet-dot">•</span>
//           <span>{trimmed.replace(/^[•\-]\s*/, "")}</span>
//         </div>
//       );
//       return <p key={idx} className="cp-paragraph">{trimmed}</p>;
//     });
//   };

//   if (loading) {
//     return (
//       <>
//         <Navbar />
//         <div className="cp-loading-container">
//           <div className="cp-loading-hero" />
//           <div className="cp-loading-content">
//             <div className="cp-loading-title" />
//             {[1,2,3,4,5].map(i => <div key={i} className="cp-loading-line" />)}
//           </div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   return (
//     <>
//       <Navbar />
//       <div className="cp-container">

//         {/* ===== HERO ===== */}
//         <div className="cp-hero">
//           {policy?.ImageKey ? (
//             <img src={policy.ImageKey} alt="Banner" className="cp-hero-img"
//               onError={(e) => { e.target.style.display = "none"; }} />
//           ) : (
//             <div className="cp-hero-placeholder" />
//           )}
//           <div className="cp-hero-overlay">
//             <h1 className="cp-hero-title">
//               {policy?.title || "Shipping & Delivery Policy"}
//             </h1>
//             <div className="cp-hero-divider" />
//             <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.85rem", marginTop: "8px" }}>
//               Last updated on {policy?.createdAt
//                 ? new Date(policy.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
//                 : "Oct 3 2025"}
//             </p>
//           </div>
//         </div>

//         {/* ===== CONTENT CARD ===== */}
//         <div className="cp-main">
//           <div className="cp-card">

//             {/* Card Header */}
//             <div className="cp-card-header">
//               <div className="cp-card-icon">🚚</div>
//               <div>
//                 <h2 className="cp-card-title">
//                   {policy?.title || "Shipping & Delivery Policy"}
//                 </h2>
//               </div>
//             </div>

//             <div className="cp-divider" />

//             {/* Policy Content */}
//             <div className="cp-content">
//               {renderContent(policy?.description)}
//             </div>

//             <div className="cp-divider" />

//             {/* ===== CONTACT INFO — Dynamic ===== */}
//             <div className="cp-footer-note" style={{ flexDirection: "column", gap: "16px" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                 <span className="cp-footer-icon">📞</span>
//                 <p style={{ margin: 0, fontWeight: 600, fontSize: "0.95rem", color: "#444" }}>
//                   For any issues, contact our helpdesk:
//                 </p>
//               </div>

//               {contactInfo ? (
//                 <div style={{ display: "flex", flexDirection: "column", gap: "8px", paddingLeft: "4px" }}>
//                   {contactInfo.Email && (
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                       <span style={{ fontSize: "1rem" }}>✉️</span>
//                       <p style={{ margin: 0, fontSize: "0.88rem", color: "#555" }}>
//                         <strong>Email:</strong>{" "}
//                         <a href={`mailto:${contactInfo.Email}`}
//                           style={{ color: "var(--theme-color1)", textDecoration: "none" }}>
//                           {contactInfo.Email}
//                         </a>
//                       </p>
//                     </div>
//                   )}
//                   {contactInfo.Phone && (
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                       <span style={{ fontSize: "1rem" }}>📱</span>
//                       <p style={{ margin: 0, fontSize: "0.88rem", color: "#555" }}>
//                         <strong>Phone:</strong>{" "}
//                         <a href={`tel:+91${contactInfo.Phone}`}
//                           style={{ color: "var(--theme-color1)", textDecoration: "none" }}>
//                           +91 {contactInfo.Phone}
//                         </a>
//                       </p>
//                     </div>
//                   )}
//                   {contactInfo.Address && (
//                     <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
//                       <span style={{ fontSize: "1rem" }}>📍</span>
//                       <p style={{ margin: 0, fontSize: "0.88rem", color: "#555" }}>
//                         <strong>Address:</strong> {contactInfo.Address}
//                       </p>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <p style={{ margin: 0, fontSize: "0.88rem", color: "#888" }}>
//                   Contact information not available.
//                 </p>
//               )}
//             </div>

//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default ShippingPolicy;

import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../pages/main/footer";
import "./CancellationPolicy.css"; // reuse same CSS
import api from "../services/httpService";

const ShippingPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    fetchPolicy();
    fetchContact();
    fetchThemeColors();
  }, []);

  /* ================= THEME COLORS ================= */
  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");

      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          const color1 = latest.color1 || "#f83600";
          const color2 = latest.color2 || "#fe8c00";

          document.documentElement.style.setProperty("--theme-color1", color1);
          document.documentElement.style.setProperty("--theme-color2", color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  /* ================= POLICY ================= */
  const fetchPolicy = async () => {
    try {
      const res = await api.get("/sentinix/shippinganddelivery");

      if (res.data.success && res.data.data) {
        const data = Array.isArray(res.data.data)
          ? res.data.data.filter(d => !d.isDeleted).sort((a, b) => b.id - a.id)[0]
          : res.data.data;

        setPolicy(data || null);
      }
    } catch (err) {
      console.error("Error fetching shipping policy:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= CONTACT ================= */
  const fetchContact = async () => {
    try {
      const res = await api.get("/sentinix/contactforms");

      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        const info = allData.find(item => item.title && item.title.trim() !== "");
        setContactInfo(info || null);
      }
    } catch (err) {
      console.error("Error fetching contact:", err);
    }
  };

  /* ================= CONTENT FORMAT ================= */
  const renderContent = (text) => {
    if (!text) return <p className="cp-empty">No content available.</p>;

    return text.split("\n").map((line, idx) => {
      const trimmed = line.trim();
      if (!trimmed) return <br key={idx} />;

      const isSubHeading = /^\d+\.\d+/.test(trimmed);
      const isHeading = /^\d+\./.test(trimmed);
      const isBullet = trimmed.startsWith("•") || trimmed.startsWith("-");

      if (isSubHeading)
        return <h4 key={idx} className="cp-subheading">{trimmed}</h4>;

      if (isHeading)
        return <h3 key={idx} className="cp-heading">{trimmed}</h3>;

      if (isBullet)
        return (
          <div key={idx} className="cp-bullet">
            <span className="cp-bullet-dot">•</span>
            <span>{trimmed.replace(/^[•-]\s*/, "")}</span>
          </div>
        );

      return <p key={idx} className="cp-paragraph">{trimmed}</p>;
    });
  };

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <>
        <Navbar />
        <div className="cp-loading-container">
          <div className="cp-loading-hero" />
          <div className="cp-loading-content">
            <div className="cp-loading-title" />
            {[1, 2, 3, 4, 5].map(i => (
              <div key={i} className="cp-loading-line" />
            ))}
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <div className="cp-container">
        {/* ================= HERO ================= */}
        <div className="svc-hero">
          {policy?.ImageKey ? (
            <img
              src={policy.ImageKey}
              alt="Banner"
              className="svc-hero-img"
              onError={(e) => (e.target.style.display = "none")}
            />
          ) : (
            <div className="cp-hero-placeholder" />
          )}

          <div className="cp-hero-overlay">
            {/* <h1 className="cp-hero-title">
              {policy?.title || "Shipping & Delivery Policy"}
            </h1> */}

            <div className="cp-hero-divider" />

            <p className="cp-hero-date">
              Last updated on{" "}
              {policy?.createdAt
                ? new Date(policy.createdAt).toLocaleDateString("en-IN", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })
                : "Oct 3 2025"}
            </p>
          </div>
        </div>

        {/* ================= CONTENT ================= */}
        <div className="cp-main">
          <div className="cp-card">
            <div className="cp-card-header">
              <div className="cp-card-icon">🚚</div>
              <h2 className="cp-card-title">
                {policy?.title || "Shipping & Delivery Policy"}
              </h2>
            </div>

            <div className="cp-divider" />

            <div className="cp-content">
              {renderContent(policy?.description)}
            </div>

            <div className="cp-divider" />

            {/* ================= CONTACT ================= */}
            <div className="cp-footer-note" style={{ flexDirection: "column", gap: "14px" }}>
              <strong>For any issues, contact our helpdesk:</strong>

              {contactInfo ? (
                <>
                  {contactInfo.Email && (
                    <p>
                      <b>Email:</b>{" "}
                      <a href={`mailto:${contactInfo.Email}`} style={{ color: "var(--theme-color1)" }}>
                        {contactInfo.Email}
                      </a>
                    </p>
                  )}
                  {contactInfo.Phone && (
                    <p>
                      <b>Phone:</b>{" "}
                      <a href={`tel:+91${contactInfo.Phone}`} style={{ color: "var(--theme-color1)" }}>
                        +91 {contactInfo.Phone}
                      </a>
                    </p>
                  )}
                  {contactInfo.Address && (
                    <p><b>Address:</b> {contactInfo.Address}</p>
                  )}
                </>
              ) : (
                <p>Contact information not available.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ShippingPolicy;